import {Component} from '@angular/core';
import {Router} from '@angular/router';
import {HttpClient} from '@angular/common/http';
import {CommonModule} from '@angular/common';
import {FormBuilder, FormGroup, ReactiveFormsModule, Validators} from '@angular/forms';
import {FaIconLibrary, FontAwesomeModule} from '@fortawesome/angular-fontawesome';
import {faUnlockKeyhole} from '@fortawesome/free-solid-svg-icons';
import {ToastrService} from 'ngx-toastr';
import {ApiService} from '../../../services/api.service';
import {validateAllFormFields} from '../../../../common/utils';
import {LoadingService} from '../../../services/loading.service';

@Component({
    selector: 'app-forgot-password',
    imports: [CommonModule, ReactiveFormsModule, FontAwesomeModule],
    templateUrl: './forgot-password.component.html',
    styleUrl: './forgot-password.component.css'
})
export class ForgotPasswordComponent {
  forgotPasswrdForm: FormGroup;


  constructor(private http: HttpClient,
              private router: Router,
              library: FaIconLibrary,
              private apiService: ApiService, 
              fb: FormBuilder,
              private toastr:ToastrService,
              public loadingService: LoadingService
            ) {
    library.addIcons(faUnlockKeyhole)

    this.forgotPasswrdForm = fb.group({
        email: ['',  Validators.required]
    });
  }
  
  get email(){
    return this.forgotPasswrdForm.get('email');
  }

  onSubmit(){
    if (this.forgotPasswrdForm.valid) {
      this.loadingService.setLoading('forgot-password', true);

      let formdata = new FormData();
      formdata.append('email', this.forgotPasswrdForm.value.email.toLowerCase());

      this.apiService.forgotPassword(formdata).subscribe({
        next: (res: any) => {
          this.toastr.success(res['detail'], 'Success');
          this.loadingService.setLoading('forgot-password', false);
        },
        error: (err) => {
          this.loadingService.setLoading('forgot-password', false);
          this.toastr.error(err['error']['email'], 'Error');
        }
      })
    } else{
      validateAllFormFields(this.forgotPasswrdForm);
    }
  }
  login(){
    return this.router.navigate(['login/'])
  }
}
